import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import SideBar from "../components/SideBar";
import UpperTotal from "../components/UpperTotal";
import {
  faCircle,
  faArrowDown,
  faArrowUp,
  faUser,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import { faBell, faComment } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import "@inovua/reactdatagrid-community/index.css";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Breadcrumbs from "../components/Breadcrumbs";
import UserIcon from "../components/UserIcon";
import NetworkError from "../components/Modals/NetworkError";
import Loading from "../components/Loading";
import Swal from "sweetalert2";
import { categoryName } from "../utils/translations";
function OffersDetails() {
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [values, setValues] = useState({});
  const changeHandler = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  let { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  let offerId = queryParams.get("id");
  const [offer, setOffer] = useState(null);

  const fetchOffer = async () => {
    const response = await axios.get(
      `${"https://api.sedihisham.com"}/offers/${offerId}`
    );
    setValues({
      offerName: response.data.name,
      value: response.data.percentage,
      appliesTo: "",
      expirationDate: response.data.expiry_date.slice(0, 10),
    });
    setOffer(response.data);
  };

  useEffect(() => {
    fetchOffer();
  }, []);

  const updateOffer = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(`${"https://api.sedihisham.com"}/offers/update/${offerId}`, {
        offer_name: values.offerName,
        value: parseInt(values.value),
        applies_to_arr_cat: values.appliesTo,
        expiry_date: values.expirationDate,
      })
      .then(function (response) {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Your changes had been saved",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch(function (error) {
        console.log(error);
        if (error.code === "ERR_NETWORK") {
          setLoading(false);
          setShowError(true);
          setTimeout(() => {
            setShowError(false);
          }, 3000);
        }
      });
  };

  //  MULTI SELECTOR

  const [categories, setCategories] = useState([]);
  const fetchCategories = async () => {
    const response = await axios.get(
      `${"https://api.sedihisham.com"}/categories/findall`
    );
    const data = response.data;
    if (data.length !== categories.length) {
      setCategories(data);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);
  var optionsArray = [];
  const [options, setOptions] = useState([]);
  useEffect(() => {
    categories.map((category) => {
      optionsArray = [
        ...optionsArray,
        {
          value: category.id,
          label: categoryName(category),
        },
      ];
    });
    setOptions(optionsArray);
  }, [categories]);

  const [preSelected, setPreSelected] = useState([]);
  var selectDefault = [];
  var selectCatIds = [];
  useEffect(() => {
    if (offer) {
      offer.Categories.map((category) => {
        selectDefault = [
          ...selectDefault,
          {
            value: category.id,
            label: categoryName(category),
          },
        ];
        selectCatIds = [...selectCatIds, category.id];
      });
      setPreSelected(selectDefault);
      setValues({ ...values, appliesTo: selectCatIds });
    }
  }, [offer]);

  const multiSelectOnChange = (selectedOptions) => {
    var selected = [];
    selectedOptions.map((option) => {
      selected = [...selected, option.value];
    });
    setValues({ ...values, appliesTo: selected });
  };

  return (
    <form onSubmit={updateOffer}>
      <div className="w-[96%] text-[17px] m-auto mt-6">
        <div className="m-auto mt-6 flex">
          <div>
            <SideBar />
          </div>
          <div className="w-full flex flex-col ml-6 text-[#033362] font-semibold">
            <div className="flex justify-between items-center w-full">
              <Breadcrumbs
                breads={[
                  {
                    title: "Offers",
                    link: "/offers?tab=1",
                  },
                  {
                    title: `Offer Details (${offerId})`,
                    link: `/offer-details?id=${offerId}`,
                  },
                ]}
              />
              <div className="flex items-center h-8 w-[30%]">
                <UserIcon />
              </div>
            </div>
            <div className="bg-[white] grow mt-2 rounded-xl shadow-[0px_0px_16px_rgb(210,215,211)]">
              <div className=" py-12 px-28">
                {/* {} */}
                <div className="flex">
                  <div className="w-[20%] text-[14px] mr-4 font-[500]">
                    <label htmlFor="offer-name">
                      Offer Name <span className="text-[red]">*</span>
                    </label>
                  </div>
                  <input
                    required
                    className="w-[72.2%] h-[35px] pr-[40px] mr-2 rounded border-[#0388CC] placeholder:text-[center] placeholder:text-[12px] placeholder:font-[400]"
                    placeholder="Enter offer name"
                    onChange={changeHandler}
                    value={values.offerName}
                    name="offerName"
                    type="text"
                    id="offer-name"
                  />
                </div>
                {/* {} */}
                <div className="flex mt-6">
                  <div className="w-[20%] text-[14px] mr-4 font-[500]">
                    <label htmlFor="value">
                      Value <span className="text-[red]">*</span>
                    </label>
                  </div>
                  <input
                    required
                    className="w-[30%] pr-[115px] h-[35px] mr-2 rounded border-[#0388CC] placeholder:text-[center] placeholder:text-[12px] text-[14px] placeholder:font-[400] font-[400]"
                    placeholder="Enter offer percentage"
                    onChange={changeHandler}
                    value={values.value}
                    name="value"
                    type="text"
                    id="value"
                  />
                  <span className="ml-[-115px] pl-1 border-l-2 border-l-[#0388CC]  text-[#0388CC] flex items-center text-[14px] font-[400]">
                    Percentage %
                  </span>
                </div>
                <div className="flex mt-6">
                  <div className="w-[20%] text-[14px] mr-4 font-[500]">
                    <label htmlFor="applies-to">
                      Applies To <span className="text-[red]">*</span>
                    </label>
                  </div>
                  <div className="w-[500px]">
                    {preSelected.length !== 0 ? (
                      <Select
                        isMulti
                        options={options}
                        defaultValue={preSelected?.map((ele) => ele)}
                        onChange={multiSelectOnChange}
                      />
                    ) : null}
                    {preSelected.length === 0 ? (
                      <Select
                        isMulti
                        options={options}
                        onChange={multiSelectOnChange}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="flex mt-6">
                  <div className="w-[20%] text-[14px] mr-4 font-[500]">
                    <label htmlFor="expiration-date">
                      Expiration Date <span className="text-[red]">*</span>
                    </label>
                  </div>
                  <input
                    required
                    className="w-[20%] h-[35px] mr-2 rounded border-[#0388CC] placeholder:text-[center] placeholder:text-[12px] text-[12px] font-[400] placeholder:font-[400]"
                    type="date"
                    onChange={changeHandler}
                    value={values.expirationDate}
                    name="expirationDate"
                    id="expiration-date"
                  />
                </div>
              </div>
              {showError ? <NetworkError setShowModal={setShowError} /> : null}
              {loading ? <Loading /> : null}
              <div className="absolute flex pb-[10px] right-[80px] bottom-[0px]">
                <div
                  onClick={() => navigate(-1)}
                  className="cursor-pointer rounded-full text-[13px] mr-2 px-6 py-1 text-[#0388CC] bg-[#E9F6FD]"
                >
                  Cancel
                </div>
                <input
                  type="submit"
                  className="cursor-pointer rounded-full text-[13px] px-6 py-1 text-[#fff] bg-[#0388CC]"
                  value="Save"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mb-[10px] flex justify-center text-[14px] text-[#707070] bg-[#fff] h-7 rounded-xl mt-2 items-center font-normal shadow-[0px_0px_16px_rgb(210,215,211)]">
          Copyright © 2023 . Powered by BIGBANG Information Technology
          Solutions.
        </div>
      </div>
    </form>
  );
}

export default OffersDetails;
